import React from 'react';
import { connect } from 'react-redux';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ContactForm from './ContactForm';
import * as actions from '../actions/index';

const Contact = ({submitContactForm}) => {          

    return (
        <div style={{
            background: 'linear-gradient(135deg, rgba(232, 232, 232, 0.92) 0%, rgba(248,250,252,0.95) 100%)',
            minHeight: 'auto',
            padding: '120px 60px 50px 60px',
            margin: '0',
            width: '100%'
        }}>
                <div style={{ width: '100%', maxWidth: 'none' }}>
                    {/* Header Section */}
                    <Row className="justify-content-center mb-5">
                        <Col lg={8} className="text-center">
                            <h1 style={{
                                fontSize: '3rem',
                                fontWeight: '300',
                                color: '#2d3748',
                                marginBottom: '0',
                                fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif'
                            }}>
                                Contact
                            </h1>
                        </Col>
                    </Row>
                    
                    {/* Contact Form Section */}
                    <Row className="justify-content-center">
                        <Col lg={8} md={10}>
                            <ContactForm onSubmitContact={submitContactForm} />
                        </Col>
                    </Row>
                </div>
        </div>
    );
};

function mapStateToProps() {
    return {};
}

export default connect(mapStateToProps, actions)(Contact);